import React from 'react';
import { Table, Button } from 'antd';
import TagSearch from './TagSearch';
import OrderDetail from './OrderDetail';
import { getOrders, getChannels } from '../api';
import { filterResults, fieldSort } from '../util';

const columnMap = {
  remoteOrderId: 'Order Id',
  purchaseDate: 'Date',
  buyerName: 'Customer',
  orderItems: 'Items',
  grandTotal: 'Total',
  orderStatus: 'Order Status',
  serviceSku: 'Marketplace'
};

const marketplaceMap = {
  CU_AMZ_COM: 'Amazon.com marketplace',
  CU_AMZ_UK: 'Amazon.co.uk marketplace',
  CU_AMZ_DE: 'Amazon.de marketplace',
  CU_AMZ_FR: 'Amazon.fr marketplace',
  CU_AMZ_ES: 'Amazon.es marketplace',
  CU_AMZ_JP: 'Amazon.co.jp marketplace',
  CU_AMZ_CN: 'Amazon.cn marketplace',
  CU_AMZ_IT: 'Amazon.it marketplace',
  CU_AMZ_CA: 'Amazon.ca marketplace',
  CU_EBAY_COM: 'eBay.com marketplace',
  CU_EBAY_UK: 'eBay.co.uk marketplace',
  CU_EBAY_FR: 'eBay.fr marketplace',
  CU_EBAY_DE: 'eBay.de marketplace',
  CU_TESCO_COM: 'Tesco marketplace',
  CU_NEWEGG_COM: 'Newegg marketplace',
  CU_ETSY_COM: 'Etsy Marketplace'
};

const columnList = [];
const columnDirectory = {};

for (let key in columnMap) {
  let item = {
    title: columnMap[key],
    dataIndex: key,
    key: key,
    sorter: key !== 'orderItems'
  };

  columnDirectory[key] = item;
  columnList.push(key);
}

class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filteredInfo: null,
      sortedInfo: {},
      filteredData: [],
      data: [],
      search: ''
    };
  }

  componentDidMount() {
    this.fetch();
  }

  fetch = async () => {
    this.setState({ loading: true });
    const channels = await getChannels();

    Promise.all(channels.map(channel => getOrders(channel.id))).then(orders => {
      const data = orders
        .reduce((arr, list) => arr.concat(list), [])
        .filter(Boolean);
      this.setState({
        loading: false,
        filteredData: data,
        data: data
      });
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const { field } = sorter;
    const { filteredData } = this.state;
    this.setState({
      filteredData: fieldSort(
        filteredData,
        field,
        sorter.order,
        field === 'grandTotal'
      ),
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };

  onSearch = tags => {
    const filteredData = filterResults(tags, this.state.data, columnDirectory);
    this.setState({ search: tags, filteredData });
  };

  handleSyncClick = () => {
    // *** Perform Sync here
  };

  render() {
    const { loading, filteredData, sortedInfo, search } = this.state;

    const displayColumns = [];

    columnList.forEach(colKey => {
      const column = columnDirectory[colKey];
      if (!column.key) {
        return;
      }

      if (colKey === 'serviceSku') {
        displayColumns.push({
          ...column,
          sortOrder:
            (column.sorter &&
              sortedInfo.columnKey === column.key &&
              sortedInfo.order) ||
            false,
          render: (value, row) => (
            <span>
              {(row.serviceSku && marketplaceMap[row.serviceSku]) || ''}
            </span>
          )
        });
        return;
      }

      if (colKey === 'orderItems') {
        displayColumns.push({
          ...column,
          render: (value, row) => (
            <span>
              {(!row.orderItems || !row.orderItems[0]) && ''}
              {row.orderItems &&
                row.orderItems[0] &&
                `${row.orderItems[0].sku} x ${row.orderItems[0].quantity} ${
                  row.orderItems[0].price
                }`}
            </span>
          )
        });
        return;
      }

      displayColumns.push({
        ...column,
        sortOrder:
          (column.sorter &&
            sortedInfo.columnKey === column.key &&
            sortedInfo.order) ||
          false
      });
    });

    return (
      <main>
        <div className="container__listings container__listings--left" />
        <div className="container__listings container__listings--right">
          <TagSearch
            placeholder="Search..."
            onChange={this.onSearch}
            value={search}
            className="item__listings--right search__listings"
          />
        </div>
        <br />
        <br />
        <Table
          rowKey="remoteOrderId"
          columns={displayColumns}
          dataSource={filteredData}
          loading={loading}
          onChange={this.handleTableChange}
          scroll={{ x: '130%' }}
          className="table__orders"
          expandedRowRender={details => (
            <OrderDetail details={details} columnMap={columnMap} />
          )}
          pagination={{
            defaultPageSize: 50,
            showSizeChanger: true,
            pageSizeOptions: ['25', '50', '100', '200']
          }}
        />
      </main>
    );
  }
}

export default Orders;
